import React, { useState } from 'react';
import classNames from 'classnames';
import Navbar from '../../navbar';
import PaymentStaff from '../../staff/payment-staff';
import UserPassword from '../user-passwords/user-password';
import StaffWeekend from '../weekends/staff-weekends';
import { ACCESS_LEVEL } from '../../../store/auth/auth.constants';
import CredentialProxy from '../proxies/credential-proxy';
import { getMenuIcon } from '../../icons/menu';
import SettingPermissions from '../setting-permissions/settingPermissions';
import SettingAgency from '../agency-settings/agency-settings';
import CredentialsPage from '../creds-list/creds-list';
import ShareLinksPage from '../shared-links/shared-links';
import Payment from '../payments/payment';


const MenuPageTabs = ({ accessLevel }) => {

  const [tabActive, setTabActive] = useState('card');

  const sideBarElemCardIsActiveClass = classNames('profile-page-sidebar-elem', {
    'profile-page-sidebar-elem--active': tabActive === 'card'
  });

  const sideBarElemChangePasswordIsActiveClass = classNames('profile-page-sidebar-elem', {
    'profile-page-sidebar-elem--active': tabActive === 'change-password'
  });

  const sideBarElemWeekendIsActiveClass = classNames('profile-page-sidebar-elem', {
    'profile-page-sidebar-elem--active': tabActive === 'weekend'
  });

  const sideBarElemProxyIsActiveClass = classNames('profile-page-sidebar-elem', {
    'profile-page-sidebar-elem--active': tabActive === 'proxy'
  });

  const sideBarElemSettingPermissionIsActiveClass = classNames('profile-page-sidebar-elem', {
    'profile-page-sidebar-elem--active': tabActive === 'settingPermissions'
  });

  const sideBarElemSettingAgencyIsActiveClass = classNames('profile-page-sidebar-elem', {
    'profile-page-sidebar-elem--active': tabActive === 'settingAgency'
  });

  const sideBarElemCredentialsIsActiveClass = classNames('profile-page-sidebar-elem', {
    'profile-page-sidebar-elem--active': tabActive === 'credentials'
  });

  const sideBarElemPaymentsIsActiveClass = classNames('profile-page-sidebar-elem', {
    'profile-page-sidebar-elem--active': tabActive === 'payments'
  });


  const sideBarElemShareLinksIsActiveClass = classNames('profile-page-sidebar-elem', {
    'profile-page-sidebar-elem--active': tabActive === 'links'
  });

  return (
    <div className='profile-page'>
      <Navbar />

      <div className='under-navbar-content'>
        <div className='profile-page__container'>
          <div className='profile-page-sidebar'>
            <div className='profile-page-sidebar__title profile-page__headline-title'>Меню</div>
            <div className='profile-page-sidebar-list'>
              <div className={sideBarElemCardIsActiveClass} onClick={() => setTabActive('card')}>
                <div className='profile-page-sidebar-elem__icon'>
                  {getMenuIcon('card')}
                </div>
                <div className='profile-page-sidebar-elem__text'>Реквизиты для выплаты</div>
              </div>
              <div
                className={sideBarElemChangePasswordIsActiveClass}
                onClick={() => setTabActive('change-password')}
              >
                <div className='profile-page-sidebar-elem__icon'>
                  {getMenuIcon('password')}
                </div>
                <div className='profile-page-sidebar-elem__text'>Смена пароля</div>
              </div>
              <div
                className={sideBarElemWeekendIsActiveClass}
                onClick={() => setTabActive('weekend')}
              >
                <div className='profile-page-sidebar-elem__icon'>
                  {getMenuIcon('weekend')}
                </div>
                <div className='profile-page-sidebar-elem__text'>Выходной</div>
              </div>
              {accessLevel === ACCESS_LEVEL.agency && (
                <div className={sideBarElemProxyIsActiveClass} onClick={() => setTabActive('proxy')}>
                  <div className='profile-page-sidebar-elem__icon'>
                    {getMenuIcon('proxy')}
                  </div>
                  <div className='profile-page-sidebar-elem__text'>Прокси</div>
                </div>
              )}
              {accessLevel === ACCESS_LEVEL.agency && (
                <div className={sideBarElemSettingPermissionIsActiveClass} onClick={() => setTabActive('settingPermissions')}>
                  <div className='profile-page-sidebar-elem__icon'>
                    {getMenuIcon('proxy')}
                  </div>
                  <div className='profile-page-sidebar-elem__text'>Права доступа</div>
                </div>
              )}
              {accessLevel === ACCESS_LEVEL.agency && (
                <div className={sideBarElemSettingAgencyIsActiveClass} onClick={() => setTabActive('settingAgency')}>
                  <div className='profile-page-sidebar-elem__icon'>
                    {getMenuIcon('proxy')}
                  </div>
                  <div className='profile-page-sidebar-elem__text'>Финансы</div>
                </div>
              )}
              {accessLevel === ACCESS_LEVEL.agency && (
                <div className={sideBarElemCredentialsIsActiveClass} onClick={() => setTabActive('credentials')}>
                  <div className='profile-page-sidebar-elem__icon'>
                    {getMenuIcon('proxy')}
                  </div>
                  <div className='profile-page-sidebar-elem__text'>Credentials</div>
                </div>
              )}
              {accessLevel === ACCESS_LEVEL.agency && (
                <div className={sideBarElemPaymentsIsActiveClass} onClick={() => setTabActive('payments')}>
                  <div className='profile-page-sidebar-elem__icon'>
                    {getMenuIcon('proxy')}
                  </div>
                  <div className='profile-page-sidebar-elem__text'>Платежи</div>
                </div>
              )}
              {accessLevel === ACCESS_LEVEL.agency && (
                <div className={sideBarElemShareLinksIsActiveClass} onClick={() => setTabActive('links')}>
                  <div className='profile-page-sidebar-elem__icon'>
                    {getMenuIcon('proxy')}
                  </div>
                  <div className='profile-page-sidebar-elem__text'>Shared Links</div>
                </div>
              )}
            </div>
          </div>

          <div className='profile-page-info'>
            {tabActive === 'card' && (
              <>
                <div className='profile-page__headline-title'>Основная информация</div>
                <PaymentStaff userId={'self'} />
              </>
            )}
            {tabActive === 'change-password' && (
              <UserPassword />
            )}
            {tabActive === 'weekend' && (
              <StaffWeekend />
            )}
            {(accessLevel === ACCESS_LEVEL.agency && tabActive === 'proxy') && (
              <CredentialProxy />
            )}
            {(accessLevel === ACCESS_LEVEL.agency && tabActive === 'settingPermissions') && (
              <SettingPermissions />
            )}
            {(accessLevel === ACCESS_LEVEL.agency && tabActive === 'settingAgency') && (
              <SettingAgency />
            )}
            {(accessLevel === ACCESS_LEVEL.agency && tabActive === 'credentials') && (
              <CredentialsPage />
            )}
            {(accessLevel === ACCESS_LEVEL.agency && tabActive === 'payments') && (
              <Payment />
            )}
            {(accessLevel === ACCESS_LEVEL.agency && tabActive === 'links') && (
              <ShareLinksPage />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MenuPageTabs;